import { CloudOffOutlineIcon } from './CloudOffOutlineIcon';

/**
 * author: Google
 * id E19C3062-FFE5-441C-91C8-B1792E3AA3CA
 * name cloud-off-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-off-outline.svg
 * tags
 * - Cloud 
 * - Weather 
 */
export const LocalIcon = CloudOffOutlineIcon;
export default LocalIcon